import {
  OnboardingStep,
  ReRequestedStepSubtype,
  UserProfile,
} from "@/generated-api";
import { AnimatePresence, motion } from "framer-motion";
import OnboardingForm from "./data-form/OnboardingForm";
import PhotoUploadGrid from "./PhotoUploadGrid";
import FaceVerification from "./FaceVerification";
import TermsAndLanguage from "./TermsAndLanguage";
import { Dialog } from "../ui/dialog";
import { useEffect, useState } from "react";
import StepTracker from "./StepTracker";
import envelope from "../../assets/envelope-confirmation-cropped.avif";
import PhotoResubmitModalDefault from "./PhotoResubmitModalDefault";
import PhotoResubmitModalElegant from "./PhotoResubmitModalElegant";
import OnboardingApplied from "./OnboardingApplied";
import OnboardingWaitlisted from "./OnboardingWaitlisted";

export default function OnboardingFlow({ user }: { user: UserProfile }) {
  const photoModalOpen = user.re_requested_step === OnboardingStep.PHOTO_UPLOAD;
  const [requestModalOpen, setRequestModalOpen] = useState(photoModalOpen);

  useEffect(() => {
    if (user.onboarding_step === OnboardingStep.FACE_VERIFICATION) {
      const preloadImages = [envelope];
      preloadImages.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    }
  }, [user.onboarding_step]);

  function PhotoResubmitModal() {
    return (
      <Dialog open={requestModalOpen} onOpenChange={setRequestModalOpen}>
        {user.re_requested_step_subtype ===
        ReRequestedStepSubtype.PHOTOS_ELEGANT ? (
          <PhotoResubmitModalElegant />
        ) : (
          <PhotoResubmitModalDefault />
        )}
      </Dialog>
    );
  }
  return (
    <div className="flex flex-col h-full w-full">
      {(user.onboarding_step === OnboardingStep.FORM ||
        user.onboarding_step === OnboardingStep.PHOTO_UPLOAD ||
        user.onboarding_step === OnboardingStep.FACE_VERIFICATION) && (
        <StepTracker step={user.onboarding_step} />
      )}

      <div className="w-full h-full flex flex-1 items-center">
        <div className="w-full mb-6">
          <AnimatePresence mode="wait">
            {user.onboarding_step === OnboardingStep.TERMS ? (
              <motion.div
                key="form"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.1 }}
              >
                <TermsAndLanguage />
              </motion.div>
            ) : user.onboarding_step === OnboardingStep.FORM ? (
              <motion.div
                key="form"
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 50 }}
                transition={{ duration: 0.1 }}
              >
                <OnboardingForm user={user} />
              </motion.div>
            ) : user.onboarding_step === OnboardingStep.PHOTO_UPLOAD ? (
              <motion.div
                key="photo-upload"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.1 }}
              >
                <PhotoUploadGrid showContinue={true} />
                <PhotoResubmitModal />
              </motion.div>
            ) : user.onboarding_step == OnboardingStep.FACE_VERIFICATION ? (
              <motion.div
                key="face-verification"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.1 }}
              >
                <FaceVerification user={user} />
              </motion.div>
            ) : user.onboarding_step === OnboardingStep.APPLIED ? (
              <motion.div
                key="applied"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.1 }}
              >
                <OnboardingApplied />
              </motion.div>
            ) : user.onboarding_step === OnboardingStep.WAITLISTED ? (
              <motion.div
                key="waitlisted"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.1 }}
              >
                <OnboardingWaitlisted />
              </motion.div>
            ) : (
              <motion.div
                key="denied"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.1 }}
              >
                <OnboardingWaitlisted />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
